const products = [
  {
    id: 'vpn',
    name: 'KOREN VPN',
    tagline: 'Privacy Without Compromise',
    description:
      'A lightning-fast, military-grade VPN for iOS that encrypts your internet traffic, hides your IP address, and keeps your online activity completely private — even on public Wi-Fi.',
    image:
      'https://public.readdy.ai/ai/img_res/93dc5dbdc2bc14ac3dab2732185e355e.jpg',
    features: ['256-bit AES Encryption', 'Zero-Log Policy', 'Global Server Network', 'Kill Switch Protection'],
    gradient: 'from-emerald-500 to-teal-600',
    iconBg: 'bg-emerald-50',
    icon: 'ri-shield-keyhole-line',
    iconColor: 'text-emerald-500',
  },
  {
    id: 'cleaner',
    name: 'KOREN Cleaner',
    tagline: 'Speed Up Your iPhone',
    description:
      'An intelligent iOS cleaner that removes junk files, duplicate photos, and unnecessary cache data to free up storage space and restore your device\'s peak performance.',
    image:
      'https://readdy.ai/api/search-image?query=modern%20iOS%20cleaner%20app%20interface%20on%20iPhone%20screen%2C%20light%20theme%20with%20circular%20progress%20indicator%20and%20storage%20stats%2C%20mint%20green%20and%20white%20color%20scheme%2C%20minimalist%20clean%20UI%2C%20simple%20white%20background%2C%20professional%20product%20photography%2C%20high%20detail%2C%20soft%20lighting&width=600&height=700&seq=cleaner001&orientation=portrait',
    features: ['Smart Junk Detection', 'Duplicate Photo Finder', 'Cache Cleaner', 'Storage Analyzer'],
    gradient: 'from-teal-500 to-cyan-600',
    iconBg: 'bg-teal-50',
    icon: 'ri-speed-up-line',
    iconColor: 'text-teal-500',
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-24 md:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16 md:mb-20">
          <p
            className="text-xs uppercase tracking-[0.3em] text-gray-400 font-semibold mb-4"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Our Products
          </p>
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            iOS Apps We've Built
          </h2>
        </div>

        {/* Product Cards */}
        <div className="flex flex-col gap-16 md:gap-24">
          {products.map((product, idx) => (
            <div
              key={product.id}
              className={`flex flex-col ${idx % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-10 lg:gap-16`}
            >
              {/* Image */}
              <div className="w-full lg:w-5/12 flex justify-center">
                <div className="relative w-64 md:w-72">
                  <div
                    className={`absolute -inset-4 rounded-3xl bg-gradient-to-br ${product.gradient} opacity-10`}
                  />
                  <img
                    src={product.image}
                    alt={product.name}
                    className="relative w-full h-80 md:h-96 object-cover object-top rounded-3xl"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="w-full lg:w-7/12">
                <div className={`inline-flex items-center justify-center w-14 h-14 rounded-2xl ${product.iconBg} mb-6`}>
                  <i className={`${product.icon} text-2xl ${product.iconColor}`} />
                </div>
                <h3
                  className="text-3xl md:text-4xl font-bold text-gray-900 mb-2"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  {product.name}
                </h3>
                <p className={`text-sm font-semibold bg-gradient-to-r ${product.gradient} bg-clip-text text-transparent mb-5`}>
                  {product.tagline}
                </p>
                <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-8">
                  {product.description}
                </p>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {product.features.map((feat) => (
                    <li key={feat} className="flex items-center gap-3 text-sm text-gray-700">
                      <span className={`w-5 h-5 flex items-center justify-center rounded-full bg-gradient-to-br ${product.gradient}`}>
                        <i className="ri-check-line text-white text-xs" />
                      </span>
                      {feat}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
